      document.addEventListener("DOMContentLoaded", function() {
        var openBtn = document.getElementById("openFormInfoModal");
        var closeBtn = document.getElementById("closeFormInfoModal");
        var modal = document.getElementById("formInfoModal");
        if (openBtn && closeBtn && modal) {
          openBtn.onclick = function() {
            modal.classList.add('active');
          }
          closeBtn.onclick = function() {
            modal.classList.remove('active');
          }
          window.onclick = function(event) {
            if (event.target == modal) {
              modal.classList.remove('active');
            }
          }
        }
      });  